__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "banco-de-conteudos";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (Promise.all([__webpack_require__.e(33), __webpack_require__.e(656), __webpack_require__.e(686), __webpack_require__.e(444), __webpack_require__.e(487)]).then(() => (() => (__webpack_require__(95495))))));
			register("@sentry/react", "8.55.0", () => (Promise.all([__webpack_require__.e(197), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(30197))))));
			register("@stitches/react", "1.2.8", () => (Promise.all([__webpack_require__.e(656), __webpack_require__.e(345)]).then(() => (() => (__webpack_require__(33345))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(26710))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(396), __webpack_require__.e(43)]).then(() => (() => (__webpack_require__(15043))))));
			register("localforage", "1.10.0", () => (__webpack_require__.e(790).then(() => (() => (__webpack_require__(73790))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(86663))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(656), __webpack_require__.e(686)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(67387);
			initExternal(47761);
			initExternal(96816);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};